module.exports = __webpack_public_path__ + "img/fuwu-ca.70dff53d.jpg";